<app-social-channels></app-social-channels>
<p-divider class="my-8"></p-divider>

<div class="card">
  <div class="mb-8 text-center">
    <h1 class="flex items-center justify-center gap-3 text-4xl font-light text-gray-800 mb-2">
      <i class="pi pi-robot text-blue-600 text-3xl"></i>
      Agentes Virtuales
    </h1>
    <p class="text-lg text-gray-600 font-normal">Configuración y gestión de agentes virtuales</p>
  </div>

  @if (loading()) {
  <div class="flex flex-col items-center justify-center py-16 gap-6">
    <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration="1s">
    </p-progressSpinner>
    <p class="text-gray-600 text-lg">Cargando agentes virtuales...</p>
  </div>
  }

  @if (!loading() && virtualAgents().length > 0) {
  <div class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm mb-8">
    <div class="p-6 border-b border-gray-100">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <i class="pi pi-cog text-green-600"></i>
            Configuraciones Disponibles
          </h3>
          <p class="text-sm text-gray-600 mt-1">Agentes virtuales disponibles para crear instancias en tiendas</p>
        </div>

        <div class="flex flex-col sm:flex-row sm:items-center gap-3">
          <div class="relative">
            <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
            <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
              placeholder="Buscar por nombre, código o shop ID..."
              class="pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent w-full sm:w-80 transition-all">
            @if (searchTerm()) {
            <button type="button" (click)="clearSearch()"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
              <i class="pi pi-times text-sm"></i>
            </button>
            }
          </div>
          <div class="flex items-center gap-2">
            <div class="text-sm text-gray-600 bg-green-300 px-3 py-1.5 rounded-full">
              <span class="font-medium">{{ filteredVirtualAgents().length }}</span> de {{ virtualAgents().length }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="divide-y divide-gray-100">
      @for (agent of filteredVirtualAgents(); track agent.id) {
      <div class="p-4 hover:bg-gray-50 transition-colors">
        <div class="grid grid-cols-[auto_auto_1fr_auto] gap-4 items-center">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center">
              <i class="pi pi-android text-white text-sm"></i>
            </div>
            <div class="flex pt-4">
              <h4 class="font-semibold text-gray-800">{{ agent.description }}</h4>
            </div>
          </div>

          <div class="flex justify-center">
            <p-tag
              [value]="agent.agent_code"
              severity="info"
              class="bg-green-100 text-green-700 font-mono font-semibold text-xs">
            </p-tag>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-600">{{ agent.shopPointName }}</span>
            <span class="text-xs text-gray-500 font-mono">Shop ID: {{ agent.shopId }}</span>
            <span class="text-xs text-gray-500 font-mono">Shop Point ID: {{ agent.shopPointId }}</span>
          </div>

          <div class="flex items-center gap-2">
            <p-tag [value]="'Config ID: ' + agent.id" severity="secondary" class="bg-gray-100 text-gray-700 text-xs">
            </p-tag>
            <button type="button" (click)="createShopAgent(agent.id)"
              class="px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors flex items-center gap-1.5">
              <i class="pi pi-android text-xs"></i>
              Crear Agente Virtual
            </button>
            <button type="button" (click)="openHumanAgentModal(agent.id)"
              class="px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors flex items-center gap-1.5">
              <i class="pi pi-user text-xs"></i>
              Crear Agente Humano
            </button>
            <button type="button" (click)="openShopPointModal(agent.id)"
              class="px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors flex items-center gap-1.5">
              <i class="pi pi-users text-xs"></i>
              Ver Agentes
            </button>
          </div>
        </div>
      </div>
      }

      @if (filteredVirtualAgents().length === 0 && searchTerm()) {
      <div class="text-center py-8">
        <i class="pi pi-search text-3xl text-gray-400 mb-3 block"></i>
        <h4 class="text-lg font-medium text-gray-700 mb-2">Sin resultados</h4>
        <p class="text-gray-600 mb-4">No se encontraron configuraciones que coincidan con "{{ searchTerm() }}"</p>
        <button type="button" (click)="clearSearch()"
          class="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors">
          Limpiar búsqueda
        </button>
      </div>
      }
    </div>
  </div>
  }

  @if (!loading() && virtualAgents().length === 0) {
  <div class="text-center py-12 bg-white rounded-xl border border-gray-200 mb-8">
    <i class="pi pi-cog text-4xl text-gray-400 mb-4 block"></i>
    <h3 class="text-lg font-semibold text-gray-800 mb-2">No hay configuraciones de agentes</h3>
    <p class="text-gray-600">No se encontraron configuraciones de agentes virtuales disponibles.</p>
  </div>
  }

  <p-divider class="my-8"></p-divider>

  <div class="mt-8">
    <div class="mb-6">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 class="flex items-center gap-3 text-2xl font-semibold text-gray-800 mb-2">
            <i class="pi pi-shop text-green-600 text-xl"></i>
            Agentes de Tienda
          </h2>
          <p class="text-gray-600">Instancias activas de agentes virtuales asignadas a tiendas específicas</p>
        </div>

        @if (!loadingShopAgents() && shopAgents().length > 0) {
        <div class="flex flex-col sm:flex-row sm:items-center gap-3">
          <div class="relative">
            <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
            <input type="text" [(ngModel)]="shopAgentsSearchTerm" (ngModelChange)="onShopAgentsSearchChange()"
              placeholder="Buscar por código, teléfono o shop ID..."
              class="pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent w-full sm:w-80 transition-all">
            @if (shopAgentsSearchTerm()) {
            <button type="button" (click)="clearShopAgentsSearch()"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
              <i class="pi pi-times text-sm"></i>
            </button>
            }
          </div>
          <div class="flex items-center gap-2">
            <div class="text-sm text-gray-600 bg-green-300 px-3 py-1.5 rounded-full">
              <span class="font-medium">{{ filteredShopAgents().length }}</span> de {{ shopAgents().length }}
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    @if (loadingShopAgents()) {
    <div class="flex justify-center py-8">
      <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4" animationDuration="1s">
      </p-progressSpinner>
    </div>
    }

    @if (!loadingShopAgents() && shopAgents().length > 0) {
    @if (filteredShopAgents().length > 0) {
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
      <div class="overflow-x-auto">
        <p-table [value]="filteredShopAgents()" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} agentes" [rowHover]="true"
          [scrollable]="true" scrollHeight="500px" styleClass="p-datatable-sm">

          <ng-template pTemplate="header">
            <tr class="bg-gray-50">
              <th class="text-left py-4 px-6 font-semibold text-gray-700">ID</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Código</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Teléfono</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Shop ID</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Estado</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Infobip Key</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Infobip URL</th>
              <th class="text-left py-4 px-6 font-semibold text-gray-700">Shop GUID</th>
              <th class="text-center py-4 px-6 font-semibold text-gray-700">Acciones</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-agent>
            <tr class="border-b border-gray-100 hover:bg-gray-50 transition-colors">
              <td class="py-4 px-6">
                <span class="font-medium text-gray-900">{{ agent.id }}</span>
              </td>
              <td class="py-4 px-6">
                <p-tag [value]="agent.agent_code" severity="info"
                  class="bg-blue-100 text-blue-800 font-mono font-semibold">
                </p-tag>
              </td>
              <td class="py-4 px-6">
                <div class="flex items-center gap-2">
                  <i class="pi pi-phone text-gray-400 text-sm"></i>
                  <span class="font-mono text-gray-700">{{ agent.phone_number }}</span>
                </div>
              </td>
              <td class="py-4 px-6">
                <span class="font-mono text-gray-700">{{ agent.shopId }}</span>
              </td>
              <td class="py-4 px-6">
                <p-tag [value]="getAgentStatus(agent.enabled)" [severity]="getAgentStatusSeverity(agent.enabled)"
                  class="font-medium">
                </p-tag>
              </td>
              <td class="py-4 px-6">
                <div class="flex items-center gap-2">
                  <span class="font-mono text-xs text-gray-700">
                    {{ isSensitiveDataVisible(agent.id, 'infobip_key') ? agent.infobip_key :
                    maskSensitiveData(agent.infobip_key) }}
                  </span>
                  <button type="button" (click)="toggleSensitiveData(agent.id, 'infobip_key')"
                    class="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors"
                    [title]="isSensitiveDataVisible(agent.id, 'infobip_key') ? 'Ocultar' : 'Mostrar'">
                    <i
                      [class]="isSensitiveDataVisible(agent.id, 'infobip_key') ? 'pi pi-eye-slash text-xs' : 'pi pi-eye text-xs'"></i>
                  </button>
                </div>
              </td>
              <td class="py-4 px-6">
                <div class="flex items-center gap-2">
                  <span class="font-mono text-xs text-gray-700">
                    {{ isSensitiveDataVisible(agent.id, 'infobip_url') ? agent.infobip_url :
                    maskSensitiveData(agent.infobip_url) }}
                  </span>
                  <button type="button" (click)="toggleSensitiveData(agent.id, 'infobip_url')"
                    class="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors"
                    [title]="isSensitiveDataVisible(agent.id, 'infobip_url') ? 'Ocultar' : 'Mostrar'">
                    <i
                      [class]="isSensitiveDataVisible(agent.id, 'infobip_url') ? 'pi pi-eye-slash text-xs' : 'pi pi-eye text-xs'"></i>
                  </button>
                </div>
              </td>
              <td class="py-4 px-6">
                <span class="font-mono text-xs text-gray-600 max-w-32 block truncate" [title]="agent.shopGuid">
                  {{ agent.shopGuid }}
                </span>
              </td>
              <td class="py-4 px-6 text-center">
                <div class="flex justify-center items-center gap-4">
                  <div class="flex items-center gap-2">
                    <p-inputSwitch [ngModel]="agent.enabled === 1" [ngModelOptions]="{standalone: true}"
                      (onChange)="toggleAgentStatus(agent)" class="scale-75">
                    </p-inputSwitch>
                    <span class="text-xs text-gray-600">
                      {{ agent.enabled === 1 ? 'Activo' : 'Inactivo' }}
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9" class="text-center py-8">
                <div class="text-gray-500">
                  <i class="pi pi-inbox text-3xl text-gray-400 mb-3 block"></i>
                  <p class="text-lg">No hay agentes de tienda configurados</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    } @else {
    <div class="bg-white rounded-xl border border-gray-200 text-center py-8">
      <i class="pi pi-search text-3xl text-gray-400 mb-3 block"></i>
      <h4 class="text-lg font-medium text-gray-700 mb-2">Sin resultados</h4>
      <p class="text-gray-600 mb-4">No se encontraron agentes que coincidan con "{{ shopAgentsSearchTerm() }}"</p>
      <button type="button" (click)="clearShopAgentsSearch()"
        class="px-4 py-2 text-sm font-medium text-green-600 hover:text-green-700 hover:bg-green-50 rounded-md transition-colors">
        Limpiar búsqueda
      </button>
    </div>
    }
    }

    @if (!loadingShopAgents() && shopAgents().length === 0) {
    <div class="text-center py-12 bg-white rounded-xl border border-gray-200">
      <i class="pi pi-phone text-4xl text-gray-400 mb-4 block"></i>
      <h3 class="text-lg font-semibold text-gray-800 mb-2">No hay agentes de tienda</h3>
      <p class="text-gray-600">No se encontraron agentes asignados a tiendas.</p>
    </div>
    }
  </div>
</div>

<p-toast position="top-right" />

<p-confirmpopup>
  <ng-template #content let-message>
    <div
      class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700 p-4 mb-4 pb-0">
      <i [class]="message.icon" class="!text-6xl text-primary-500"></i>
      <p class="text-center">{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmpopup>

<p-dialog [header]="'Crear Agente - Para: ' + (selectedVirtualAgent?.description || '')"
  [(visible)]="showCreateAgentModal" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="p-fluid" [style]="{width: '600px'}" (onHide)="closeCreateAgentModal()">

  <div class="space-y-6">
    @if (selectedVirtualAgent) {
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <h4 class="text-sm font-semibold text-blue-800 mb-2 flex items-center gap-2">
        <i class="pi pi-info-circle"></i>
        Información del Agente Virtual
      </h4>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-blue-600 font-medium">Descripción:</span>
          <span class="text-blue-800 ml-2">{{ selectedVirtualAgent.description }}</span>
        </div>
        <div>
          <span class="text-blue-600 font-medium">Punto de Tienda:</span>
          <span class="text-blue-800 ml-2">{{ selectedVirtualAgent.shopPointName }}</span>
        </div>
      </div>
    </div>
    }

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="field">
        <label for="shopId" class="block text-sm font-medium text-gray-700 mb-2">
          Shop ID <span class="text-red-500">*</span>
        </label>
        <input id="shopId" type="number" pInputText [(ngModel)]="newAgentForm.shopId" [readonly]="true"
          class="w-full bg-gray-50" placeholder="ID de la tienda">
      </div>

      <div class="field">
        <label for="agentCode" class="block text-sm font-medium text-gray-700 mb-2">
          Código del Agente <span class="text-red-500">*</span>
        </label>
        <input id="agentCode" type="text" pInputText [(ngModel)]="newAgentForm.agent_code" [readonly]="true"
          class="w-full bg-gray-50" placeholder="Código del agente">
      </div>

      <div class="field">
        <label for="phoneNumber" class="block text-sm font-medium text-gray-700 mb-2">
          Número de Teléfono <span class="text-red-500">*</span>
        </label>
        <input id="phoneNumber" type="tel" pInputText [(ngModel)]="newAgentForm.phone_number" class="w-full"
          placeholder="Ej: 50612345678">
      </div>

      <div class="field">
        <label for="shopGuid" class="block text-sm font-medium text-gray-700 mb-2">
          Shop GUID <span class="text-red-500">*</span>
        </label>
        <input id="shopGuid" type="text" pInputText [(ngModel)]="newAgentForm.shopGuid" [readonly]="true"
          class="w-full bg-gray-50 font-mono text-xs" placeholder="GUID de la tienda">
      </div>
    </div>

    <div class="space-y-4">
      <h4 class="text-sm font-semibold text-gray-800 border-b border-gray-200 pb-2">
        Configuración Infobip
      </h4>

      <div class="field">
        <label for="infobipUrl" class="block text-sm font-medium text-gray-700 mb-2">
          Infobip URL <span class="text-red-500">*</span>
        </label>
        <input id="infobipUrl" type="text" pInputText [(ngModel)]="newAgentForm.infobip_url"
          class="w-full font-mono text-sm" placeholder="Ej: abcdef.api.infobip.com">
      </div>

      <div class="field">
        <label for="infobipKey" class="block text-sm font-medium text-gray-700 mb-2">
          Infobip Key <span class="text-red-500">*</span>
        </label>
        <input id="infobipKey" type="text" pInputText [(ngModel)]="newAgentForm.infobip_key"
          class="w-full font-mono text-sm" placeholder="Api Key Infobip">
      </div>
    </div>

    <div class="field flex items-center gap-3">
      <p-checkbox [(ngModel)]="newAgentForm.enabled" [binary]="true" inputId="enabled">
      </p-checkbox>
      <label for="enabled" class="text-sm font-medium text-gray-700 cursor-pointer">
        Agente habilitado
      </label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <button type="button" pButton label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary"
        (click)="closeCreateAgentModal()" [disabled]="creatingAgent()">
      </button>
      <button type="button" pButton label="Crear Agente" icon="pi pi-check" class="p-button-success"
        (click)="submitCreateAgent()" [loading]="creatingAgent()" [disabled]="!isFormValid()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="'Seleccionar Agente Humano - Para: ' + (selectedVirtualAgentForHuman?.description || '')"
  [(visible)]="showHumanAgentModal" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="p-fluid" [style]="{width: '900px', maxHeight: '80vh'}" (onHide)="closeHumanAgentModal()">

  <div class="space-y-4">
    @if (selectedVirtualAgentForHuman) {
    <div class="bg-green-50 border border-green-200 rounded-lg p-4">
      <h4 class="text-sm font-semibold text-green-800 mb-2 flex items-center gap-2">
        <i class="pi pi-user"></i>
        Asignar Usuario a Agente Virtual
      </h4>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-green-600 font-medium">Descripción:</span>
          <span class="text-green-800 ml-2">{{ selectedVirtualAgentForHuman.description }}</span>
        </div>
        <div>
          <span class="text-green-600 font-medium">Código:</span>
          <span class="text-green-800 ml-2 font-mono">{{ selectedVirtualAgentForHuman.agent_code }}</span>
        </div>
      </div>
    </div>
    }

    <div class="flex items-center gap-3">
      <div class="relative flex-1">
        <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
        <input type="text" [(ngModel)]="humanAgentsSearchTerm" (ngModelChange)="onHumanAgentsSearchChange()"
          placeholder="Buscar por nombre, email o username..."
          class="pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent w-full transition-all">
        @if (humanAgentsSearchTerm()) {
        <button type="button" (click)="clearHumanAgentsSearch()"
          class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
          <i class="pi pi-times text-sm"></i>
        </button>
        }
      </div>
      <div class="text-sm text-gray-600 bg-green-100 px-3 py-1.5 rounded-full">
        <span class="font-medium">{{ filteredHumanAgents().length }}</span>
        @if (humanAgents().length !== filteredHumanAgents().length) {
        de {{ humanAgents().length }}
        }
        usuario(s)
      </div>
    </div>

    @if (loadingHumanAgents()) {
    <div class="text-center py-8">
      <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4"></p-progressSpinner>
      <p class="mt-3 text-gray-600">Cargando usuarios del User Pool...</p>
    </div>
    }

    @if (!loadingHumanAgents() && filteredHumanAgents().length > 0) {
    <div class="border border-gray-200 rounded-lg overflow-hidden max-h-96 overflow-y-auto">
      <div class="divide-y divide-gray-100">
        @for (user of filteredHumanAgents(); track user.username) {
        <div class="p-4 hover:bg-gray-50 transition-colors">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <div
                class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
                <i class="pi pi-user text-white text-sm"></i>
              </div>
              <div>
                <h4 class="font-semibold text-gray-800">
                  {{ getFullName(user) }}
                </h4>
                <div class="flex items-center gap-4 mt-1">
                  <span class="text-sm text-gray-600 flex items-center gap-1">
                    <i class="pi pi-envelope text-xs"></i>
                    {{ user.email }}
                  </span>
                </div>
                <div class="flex items-center gap-4 mt-1">
                  <span class="text-xs text-gray-500 font-mono flex items-center gap-1">
                    <i class="pi pi-user text-xs"></i>
                    {{ user.username }}
                  </span>
                  @if (user.attributes.phone_number) {
                  <div class="flex items-center gap-1">
                    <i class="pi pi-phone text-xs text-gray-400"></i>
                    <span class="text-xs text-gray-600">{{ user.attributes.phone_number }}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <button type="button" (click)="selectHumanAgent(user, $event)"
                [disabled]="processingUserId() === user.username"
                [class.opacity-50]="processingUserId() === user.username"
                class="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 disabled:hover:bg-green-600 rounded-md transition-colors flex items-center gap-1.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-1">
                @if (processingUserId() === user.username) {
                <i class="pi pi-spin pi-spinner text-xs"></i>
                Procesando...
                } @else {
                <i class="pi pi-check text-xs"></i>
                Seleccionar
                }
              </button>
            </div>
          </div>

          @if (user.attributes && getVisibleAttributes(user.attributes).length > 0) {
          <div class="mt-3 pt-3 border-t border-gray-100" (click)="$event.stopPropagation()">
            <details class="text-xs text-gray-600">
              <summary class="cursor-pointer hover:text-gray-800 flex items-center gap-2 select-none">
                <i class="pi pi-info-circle text-xs"></i>
                Ver más atributos ({{ getVisibleAttributes(user.attributes).length }})
              </summary>
              <div class="mt-3 space-y-2">
                @for (attr of getVisibleAttributes(user.attributes); track attr[0]) {
                <div class="bg-gray-50 rounded px-3 py-2">
                  <div class="flex justify-between items-start">
                    <span class="font-medium text-gray-700">{{ formatAttributeName(attr[0]) }}:</span>
                    <span class="ml-2 text-gray-900 text-right max-w-48 break-words">{{ attr[1] }}</span>
                  </div>
                </div>
                }
              </div>
            </details>
          </div>
          }
        </div>
        }
      </div>
    </div>
    }

    @if (!loadingHumanAgents() && filteredHumanAgents().length === 0 && humanAgentsSearchTerm()) {
    <div class="text-center py-8">
      <i class="pi pi-search text-3xl text-gray-400 mb-3 block"></i>
      <h4 class="text-lg font-medium text-gray-700 mb-2">Sin resultados</h4>
      <p class="text-gray-600 mb-4">No se encontraron usuarios que coincidan con "{{ humanAgentsSearchTerm() }}"</p>
      <button type="button" (click)="clearHumanAgentsSearch()"
        class="px-4 py-2 text-sm font-medium text-green-600 hover:text-green-700 hover:bg-green-50 rounded-md transition-colors">
        Limpiar búsqueda
      </button>
    </div>
    }

    @if (!loadingHumanAgents() && humanAgents().length === 0) {
    <div class="text-center py-8">
      <i class="pi pi-users text-4xl text-gray-400 mb-4 block"></i>
      <h3 class="text-lg font-semibold text-gray-800 mb-2">No hay usuarios disponibles</h3>
      <p class="text-gray-600">No se encontraron usuarios en el User Pool.</p>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <button type="button" pButton label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary"
        (click)="closeHumanAgentModal()">
      </button>
      <button type="button" pButton label="Refrescar Lista" icon="pi pi-refresh" class="p-button-text p-button-info"
        (click)="loadHumanAgents()" [loading]="loadingHumanAgents()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="'Agentes del Shop Point - ' + (selectedVirtualAgentForShopPoint?.shopPointName || '')"
  [(visible)]="showShopPointModal" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="p-fluid" [style]="{width: '800px', maxHeight: '80vh'}" (onHide)="closeShopPointModal()">

  <div class="space-y-4">
    @if (selectedVirtualAgentForShopPoint) {
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <h4 class="text-sm font-semibold text-blue-800 mb-2 flex items-center gap-2">
        <i class="pi pi-building"></i>
        Información del Shop Point
      </h4>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-blue-600 font-medium">Nombre:</span>
          <span class="text-blue-800 ml-2">{{ selectedVirtualAgentForShopPoint.shopPointName }}</span>
        </div>
        <div>
          <span class="text-blue-600 font-medium">Shop ID:</span>
          <span class="text-blue-800 ml-2 font-mono">{{ selectedVirtualAgentForShopPoint.shopId }}</span>
        </div>
        <div>
          <span class="text-blue-600 font-medium">Shop Point ID:</span>
          <span class="text-blue-800 ml-2 font-mono">{{ selectedVirtualAgentForShopPoint.shopPointId }}</span>
        </div>
        <div>
          <span class="text-blue-600 font-medium">Código Agente:</span>
          <span class="text-blue-800 ml-2 font-mono">{{ selectedVirtualAgentForShopPoint.agent_code }}</span>
        </div>
      </div>
    </div>
    }

    @if (loadingShopPoint()) {
    <div class="text-center py-8">
      <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4"></p-progressSpinner>
      <p class="mt-3 text-gray-600">Cargando información del shop point...</p>
    </div>
    }

    @if (!loadingShopPoint() && shopPointData()) {
    <div class="space-y-4">
      <div class="bg-white border border-gray-200 rounded-lg p-4">
        <h4 class="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <i class="pi pi-info-circle text-blue-600"></i>
          Detalles del Shop Point
        </h4>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-3">
            @if (shopPointData().shopPointName) {
            <div>
              <span class="text-sm font-medium text-gray-600">Nombre:</span>
              <p class="text-gray-800">{{ shopPointData().shopPointName }}</p>
            </div>
            }
            @if (shopPointData().shopPointLocation) {
            <div>
              <span class="text-sm font-medium text-gray-600">Ubicación:</span>
              <p class="text-gray-800">{{ shopPointData().shopPointLocation }}</p>
            </div>
            }
            @if (shopPointData().shopPointPhone) {
            <div>
              <span class="text-sm font-medium text-gray-600">Teléfono:</span>
              <p class="text-gray-800 font-mono">{{ shopPointData().shopPointPhone }}</p>
            </div>
            }
            @if (shopPointData().shopId) {
            <div>
              <span class="text-sm font-medium text-gray-600">Shop ID:</span>
              <p class="text-gray-800 font-mono">{{ shopPointData().shopId }}</p>
            </div>
            }
          </div>
          <div class="space-y-3">
            @if (shopPointData().shopPointId) {
            <div>
              <span class="text-sm font-medium text-gray-600">Shop Point ID:</span>
              <p class="text-gray-800 font-mono">{{ shopPointData().shopPointId }}</p>
            </div>
            }
            @if (shopPointData().shopPointLatitude && shopPointData().shopPointoLongitude) {
            <div>
              <span class="text-sm font-medium text-gray-600">Coordenadas:</span>
              <p class="text-gray-800 font-mono text-xs">
                {{ shopPointData().shopPointLatitude }}, {{ shopPointData().shopPointoLongitude }}
              </p>
            </div>
            }
            @if (shopPointData().shopPointStatus !== undefined) {
            <div>
              <span class="text-sm font-medium text-gray-600">Estado:</span>
              <p-tag [value]="shopPointData().shopPointStatus === 1 ? 'Activo' : 'Inactivo'"
                [severity]="shopPointData().shopPointStatus === 1 ? 'success' : 'secondary'" class="ml-2">
              </p-tag>
            </div>
            }
            @if (shopPointData().shopAgentId) {
            <div>
              <span class="text-sm font-medium text-gray-600">Agentes Asignados:</span>
              <p class="text-gray-800 text-xs font-mono">{{ getShopPointAgents().length }} agente(s)</p>
            </div>
            }
          </div>
        </div>
      </div>
      @if (getShopPointAgents().length > 0) {
      <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div class="p-4 border-b border-gray-100">
          <h4 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <i class="pi pi-users text-green-600"></i>
            Agentes Asignados ({{ getShopPointAgents().length }})
          </h4>
        </div>

        <div class="divide-y divide-gray-100 max-h-60 overflow-y-auto">
          @for (agent of getShopPointAgents(); track agent.id || agent.agentId) {
          <div class="p-4 hover:bg-gray-50 transition-colors">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <div
                  class="w-8 h-8 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center">
                  <i class="pi pi-user text-white text-xs"></i>
                </div>
                <div>
                  <h5 class="font-medium text-gray-800">
                    {{ agent.name || agent.agentName || 'Agente' }}
                  </h5>
                  <div class="mt-1 space-y-1">
                    @if (agent.agentId || agent.agent_code || agent.id) {
                    <div>
                      <span class="text-xs text-gray-600 flex items-center gap-1">
                        <i class="pi pi-id-card text-xs"></i>
                        <span class="font-mono">{{ agent.agentId || agent.agent_code || agent.id }}</span>
                      </span>
                    </div>
                    }
                    @if (agent.email || agent.phone) {
                    <div class="flex items-center gap-3">
                      @if (agent.email) {
                      <span class="text-xs text-gray-600 flex items-center gap-1">
                        <i class="pi pi-envelope text-xs"></i>
                        {{ agent.email }}
                      </span>
                      }
                      @if (agent.phone) {
                      <span class="text-xs text-gray-600 flex items-center gap-1">
                        <i class="pi pi-phone text-xs"></i>
                        {{ agent.phone }}
                      </span>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                @if (agent.status !== undefined) {
                <p-tag [value]="agent.status === 1 ? 'Activo' : 'Inactivo'"
                  [severity]="agent.status === 1 ? 'success' : 'secondary'" class="text-xs">
                </p-tag>
                }
                @if (agent.role) {
                <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                  {{ agent.role }}
                </span>
                }
                <button type="button" pButton icon="pi pi-trash"
                  class="p-button-rounded p-button-text p-button-danger p-button-sm"
                  [title]="'Eliminar agente ' + (agent.name || agent.agentId)"
                  (click)="confirmDeleteAgent(agent, $event)" style="width: 2rem; height: 2rem;">
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }

      @if (getShopPointAgents().length === 0) {
      <div class="text-center py-8 bg-gray-50 rounded-lg">
        <i class="pi pi-users text-4xl text-gray-400 mb-4 block"></i>
        <h3 class="text-lg font-semibold text-gray-800 mb-2">No hay agentes asignados</h3>
        <p class="text-gray-600">Este shop point no tiene agentes asignados actualmente.</p>
      </div>
      }
    </div>
    }

    @if (!loadingShopPoint() && !shopPointData()) {
    <div class="text-center py-8">
      <i class="pi pi-exclamation-triangle text-4xl text-gray-400 mb-4 block"></i>
      <h3 class="text-lg font-semibold text-gray-800 mb-2">No se encontraron datos</h3>
      <p class="text-gray-600">No se pudieron cargar los datos del shop point.</p>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <button type="button" pButton label="Cerrar" icon="pi pi-times" class="p-button-text p-button-secondary"
        (click)="closeShopPointModal()">
      </button>
      <button type="button" pButton label="Refrescar" icon="pi pi-refresh" class="p-button-text p-button-info"
        (click)="loadShopPointData()" [loading]="loadingShopPoint()">
      </button>
    </div>
  </ng-template>
</p-dialog>

